import { File } from "src/graphql/generated/graphql";
import { handleError } from "src/utils/error";

/**
 * Downloads an image using the download attribute to avoid CORS issues
 * @param image The image file to download
 * @param apend Additional string to append to the src URL
 * @returns Promise that resolves when download is initiated
 */
export const downloadImage = async (image: File, apend = ""): Promise<void> => {
    if (!image?.src) {
        handleError(new Error("Image source is missing"), { context: { image: image?.src }, silent: true });
        return;
    }

    // Create a temporary anchor element
    const link = document.createElement("a");

    // Set the download attribute with filename from objectKey or fall back to a default
    const filename = image.objectKey ? image.objectKey.split("/").pop() || "image.jpg" : `image_${image.id}.jpg`;

    link.download = filename;

    // Set the href to the image URL
    link.href = image.src + apend;

    // Append to the document, click it, and then remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Add a small delay to ensure download has started before enabling the button again
    return new Promise((resolve) => setTimeout(resolve, 500));
};
